import { render, staticRenderFns } from "./EscolhaPerfil.vue?vue&type=template&id=6c5f6f96&scoped=true"
import script from "./EscolhaPerfil.vue?vue&type=script&lang=js"
export * from "./EscolhaPerfil.vue?vue&type=script&lang=js"
import style0 from "./EscolhaPerfil.vue?vue&type=style&index=0&id=6c5f6f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f6f96",
  null
  
)

export default component.exports